export const tours = [
  {
    id: 1,
    name: "Party Boat",
    cardBannerText: "Best Seller",
    description:
      "Cruise across Biscayne Bay on a lively 41-foot catamaran party boat with skyline views, a DJ set, and an upbeat open-air atmosphere from departure to dock. This rental includes jet ski access, tubing, floating devices, a water mat, and room for up to 31 passengers over a 3-hour experience.",
    price: 140,
    duration: "3 hours",
    image: "/images/biscayne-party-boat.webp",
    hours: ["4:30 PM", "6:30 PM", "8:30 PM"],
    category: "Water",
    rating: 4.9,
    reviews: 312,
    highlights: [
      "41-foot catamaran",
      "Jet ski & tubing",
      "Floating devices and water mat",
      "Capacity for 31 passengers",
    ],
    includes: [
      "Music on board",
      "Water toys",
      "Life jackets",
      "Boarding assistance",
    ],
    excludes: ["Gratuity", "Personal expenses"],
  },
  {
    id: 2,
    name: "Private Van Transportation",
    description:
      "Book a private van around South Florida with a dedicated driver for airport transfers, hotel pickups, cruise port drop-offs, and custom point-to-point service.",
    price: 40,
    duration: "2 hours",
    image: "/images/private-transport-van.webp",
    hours: ["8:00 AM", "12:00 PM", "4:00 PM"],
    category: "Adventure",
    rating: 4.8,
    reviews: 198,
    highlights: [
      "Private passenger van",
      "Custom pickup and drop-off",
      "Flexible route planning",
      "Comfortable ride for groups",
    ],
    includes: [
      "Private van transport",
      "Driver",
      "Luggage assistance",
      "Scheduled pickup",
    ],
    excludes: [
      "Additional waiting time",
      "Child seat unless requested",
    ],
  },
  {
    id: 3,
    name: "Everglades Airboat Adventure",
    description:
      "Zoom through the Florida Everglades on an airboat and spot alligators, birds, and unique wildlife.",
    price: 49,
    duration: "4 hours",
    image: "/images/airboat.webp",
    hours: ["8:00 AM", "12:00 PM"],
    category: "Adventure",
    rating: 4.7,
    reviews: 445,
    highlights: [
      "Airboat ride",
      "Alligator sighting",
      "Wildlife guide",
      "Transport included",
    ],
    includes: ["Transport", "Airboat ride", "Guide", "Ear protection"],
    excludes: ["Food", "Gratuity"],
  },
  {
    id: 4,
    name: "Bahamas 1-Day Tour",
    description:
      "Cruise from Miami to the Bahamas for a same-day island escape with round-trip ferry service, free time on arrival, and optional beach or sightseeing add-ons.",
    price: 275,
    duration: "16 hours",
    image: "/images/bahamas-day-cruise.webp",
    hours: ["5:00 AM"],
    category: "Adventure",
    rating: 4.9,
    reviews: 267,
    highlights: [
      "Cruise from Miami",
      "Round-trip Bahamas ferry",
      "Same-day island visit",
      "Optional excursions available",
    ],
    includes: [
      "Round-trip cruise transport",
      "Port assistance",
      "Travel coordination",
      "Island free time",
    ],
    excludes: ["Food & drinks", "Optional excursions"],
  },
  {
    id: 5,
    name: "Miami Yacht Rentals",
    description:
      "Charter a private yacht in Miami for a flexible day on the water with skyline views, sandbar stops, and customizable cruising time for your group.",
    price: "250/hr",
    duration: "4 hours",
    image: "/images/miami-yacht-rental.webp",
    hours: ["10:00 AM", "1:00 PM", "5:00 PM"],
    category: "Water",
    rating: 4.8,
    reviews: 189,
    highlights: [
      "Private yacht charter",
      "Miami skyline views",
      "Sandbar stops",
      "Flexible group experience",
    ],
    includes: [
      "Yacht rental",
      "Captain",
      "Fuel allowance",
      "Bluetooth sound system",
    ],
    excludes: ["Crew gratuity", "Food & drinks", "Dock fees if applicable"],
  },
  {
    id: 6,
    name: "Orlando Transportation & Theme Park Tickets",
    description:
      "Head from South Florida to Orlando with round-trip transportation and bundled admission options for the major theme parks, making the day simple from pickup to return.",
    price: 349,
    duration: "14 hours",
    image: "/images/orlando-castle.webp",
    hours: ["5:30 AM", "6:00 AM"],
    category: "Adventure",
    rating: 4.6,
    reviews: 321,
    highlights: [
      "Round-trip Orlando transportation",
      "Theme park ticket options",
      "Early departure from Miami",
      "Same-day return service",
    ],
    includes: [
      "Transport",
      "Driver coordination",
      "Selected park ticket",
      "Pickup in select areas",
    ],
    excludes: ["Food & drinks", "Express passes"],
  },
  {
    id: 7,
    name: "Miami Car Rental",
    description:
      "Reserve a rental car in Miami with economy, standard, convertible, van, and exotic options for airport arrivals, hotel stays, and self-guided trips around South Florida.",
    price: 75,
    pricingModel: "per_booking",
    pricePrefix: "Starting from",
    duration: "24 hours",
    image: "/images/mustang-convertible.webp",
    hours: ["8:00 AM", "10:00 AM", "1:00 PM"],
    timeSelectionLabel: "Select Pickup Time",
    timeSelectionNote: "Choose the pickup time that works best for your rental.",
    category: "Adventure",
    rating: 4.8,
    reviews: 143,
    highlights: [
      "Economy to exotic vehicle options",
      "Airport or hotel pickup",
      "Convertible and van availability",
      "Special requests by call or text",
    ],
    includes: [
      "Vehicle selection assistance",
      "Basic insurance included",
      "Pickup coordination",
      "Mileage details at booking",
      "Standard rental guidance",
    ],
    excludes: ["Fuel", "Tolls", "Security deposit", "Additional driver fee"],
  },
  {
    id: 8,
    name: "Bayside Boat Tour",
    cardBannerText: "Most Popular",
    description:
      "The official guide to Miami's most complete 90-minute boat cruise through Biscayne Bay. Circle Star Island, Palm Island, Fisher Island, and the Port of Miami with panoramic views of the skyline, celebrity mansions, and historic islands, with departures at the top of every hour from Bayside Marketplace.",
    price: 30,
    duration: "1.5 hours",
    image: "/images/boattour.webp",
    hours: ["10:00 AM", "11:00 AM", "12:00 PM", "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM", "5:00 PM"],
    timeSelectionLabel: "Select Departure Time",
    timeSelectionNote: "Boat departures run at the top of every hour from 10:00 AM to 5:00 PM.",
    category: "Water",
    rating: 4.9,
    reviews: 512,
    highlights: [
      "Celebrity homes",
      "Star Island",
      "Miami skyline",
      "Hourly departures from 10 AM to 5 PM",
    ],
    includes: ["Boat cruise", "Life jackets", "Captain commentary"],
    excludes: ["Food & drinks", "Transportation"],
  },
  {
    id: 9,
    name: "Miami Helicopter Tour",
    description:
      "Take off over Miami for a helicopter sightseeing flight with aerial views of Biscayne Bay, the skyline, beaches, and waterfront mansions.",
    price: 125,
    duration: "45 minutes",
    image: "/images/miami-helicopter-tour.webp",
    hours: ["10:00 AM", "1:00 PM", "4:00 PM"],
    category: "Adventure",
    rating: 4.8,
    reviews: 98,
    highlights: [
      "Aerial Miami skyline views",
      "Biscayne Bay flyover",
      "Beachfront sightseeing",
      "Professional pilot",
    ],
    includes: [
      "Helicopter flight",
      "Pilot briefing",
      "Headset communication",
      "Photo opportunities",
    ],
    excludes: ["Hotel pickup", "Gratuity", "Optional video package"],
  },
  {
    id: 10,
    name: "Snorkeling in Key West",
    description:
      "Head out from Key West to snorkel clear turquoise water over living reef systems with a guided crew and gear included.",
    price: 129,
    duration: "4 hours",
    image: "/images/keywest-snorkeling.webp",
    hours: ["9:00 AM", "1:30 PM"],
    category: "Water",
    rating: 4.8,
    reviews: 234,
    highlights: [
      "Key West reef stop",
      "All equipment",
      "Snorkel guide",
      "Beginner friendly",
    ],
    includes: ["Snorkel gear", "Boat transport", "Guide", "Safety briefing"],
    excludes: ["Food & drinks"],
  },
  {
    id: 11,
    slug: "key-west-island-escape",
    name: "Key West Island Escape",
    description:
      "Travel the scenic Overseas Highway from Miami to Key West for a full day of island exploring, ocean views, and optional water activities.",
    price: 49,
    duration: "12 hours",
    image: "/images/keywest-southernmost.webp",
    hours: ["6:30 AM", "7:00 AM"],
    category: "Adventure",
    rating: 4.8,
    reviews: 176,
    highlights: [
      "Overseas Highway ride",
      "Free time in Key West",
      "Optional snorkel add-ons",
      "Round-trip transport",
    ],
    includes: [
      "Round-trip transport",
      "Tour host",
      "Hotel pickup in select areas",
      "Island map & recommendations",
    ],
    excludes: ["Food & drinks", "Optional activity upgrades"],
  },
  {
    id: 12,
    name: "Sawgrass Mills Mall Transportation",
    description:
      "Ride from Miami to Sawgrass Mills for a stress-free shopping day with round-trip transportation and plenty of free time at one of South Florida's biggest outlet destinations.",
    price: 29,
    duration: "6 hours",
    image: "/images/sawgrass-mall-tour.webp",
    hours: ["9:00 AM", "10:00 AM"],
    category: "Cultural",
    rating: 4.6,
    reviews: 154,
    highlights: [
      "Round-trip transportation",
      "Sawgrass Mills drop-off",
      "Free shopping time",
      "Comfortable coach ride",
    ],
    includes: ["Transport", "Driver", "Outlet map", "Pickup in select areas"],
    excludes: ["Food & drinks", "Shopping purchases"],
  },
  {
    id: 13,
    slug: "miami-city-tour",
    name: "Miami Hop-On Hop-Off City Tour",
    cardBannerText: "Top Pick",
    description:
      "Climb aboard an open-top double-decker and let Miami unfold around you. This hop-on hop-off pass covers the city's most iconic neighborhoods — South Beach's Art Deco blocks, Wynwood's outdoor murals, the rhythm of Little Havana, and the Downtown skyline over Biscayne Bay. Hop off wherever you want, explore at your own pace, and catch the next bus back. One $45 pass covers the full day.",
    price: 45,
    duration: "24-hour pass",
    image: "/images/bigbus.webp",
    hours: ["9:00 AM - 5:00 PM"],
    dateOnlyBooking: true,
    bookingWindowLabel: "Route runs 9:00 AM - 5:00 PM",
    category: "Cultural",
    rating: 4.7,
    reviews: 126,
    highlights: [
      "Open-top hop-on hop-off bus",
      "South Beach, Wynwood, and Little Havana access",
      "Flexible sightseeing at your own pace",
      "Miami skyline and waterfront views",
    ],
    includes: [
      "24-hour sightseeing bus ticket",
      "Open-top bus access",
      "Pre-recorded route commentary",
      "Stops near major Miami attractions",
    ],
    excludes: ["Hotel pickup", "Attraction entry", "Boat cruise unless booked as a combo"],
  },
  {
    id: 15,
    slug: "city-and-boat-2-day-pass",
    name: "City & Boat 2-Day Pass",
    description:
      "Book the 48-hour Miami city sightseeing pass with the Bayside Boat Tour included and enjoy a fuller Miami experience on both land and water over two days.",
    price: 65,
    pricePrefix: "Special",
    duration: "48-hour pass",
    image: "/images/city-boat-combo.webp",
    hours: ["10:00 AM", "11:00 AM", "12:00 PM", "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM", "5:00 PM"],
    timeSelectionLabel: "Select Boat Tour Time",
    timeSelectionNote: "Your 48-hour city pass is flexible. Choose the included boat departure time here.",
    category: "Cultural",
    rating: 4.8,
    reviews: 61,
    highlights: [
      "48-hour city sightseeing pass",
      "Bayside Boat Tour included",
      "Skyline and celebrity-home views",
      "Two-day flexibility for sightseeing",
    ],
    includes: [
      "48-hour hop-on hop-off city tour ticket",
      "Bayside Boat Tour ticket",
      "Sightseeing coordination",
      "Flexible two-day use",
    ],
    excludes: ["Food & drinks", "Optional add-ons"],
  },
  {
    id: 16,
    slug: "miami-jet-ski-rental",
    name: "Miami Jet Ski Rental",
    description:
      "Ride a jet ski on Biscayne Bay with Miami skyline views, a safety briefing, and flexible daytime departure slots for a high-energy water experience close to Miami Beach.",
    price: 125,
    pricingModel: "per_booking",
    pricePrefix: "Starting from",
    priceSuffix: "/ hour",
    duration: "1 hour",
    image: "/images/miami-jet-ski.webp",
    hours: ["10:00 AM", "11:30 AM", "1:00 PM", "2:30 PM", "4:00 PM"],
    timeSelectionLabel: "Select Ride Time",
    timeSelectionNote: "Choose the jet ski time that works best for your day on the water.",
    category: "Water",
    rating: 4.8,
    reviews: 117,
    highlights: [
      "Biscayne Bay jet ski ride",
      "Miami skyline water views",
      "Safety briefing before departure",
      "Solo or tandem-friendly experience",
    ],
    includes: [
      "Jet ski rental window",
      "Life jacket",
      "Ride orientation and safety briefing",
      "Departure coordination",
    ],
    excludes: ["Hotel pickup", "Photo package", "Security deposit if required by operator"],
  },
  {
    id: 17,
    slug: "airport-transportation",
    customPath: "/airport-transportation",
    name: "Miami Airport Transportation",
    description: "Get a route-based estimate for private transportation between Miami International Airport, Miami Beach hotels, cruise ports, and destinations across South Florida.",
    price: 40,
    pricingModel: "per_booking",
    pricePrefix: "Starting from",
    duration: "Route-based service",
    image: "/images/private-transport-van.webp",
    hours: [],
    category: "Adventure",
    rating: 4.8,
    reviews: 198,
    highlights: ["Miami International Airport pickups and drop-offs", "Live route-based estimate", "Private vehicle coordination", "One-way and round-trip options"],
    includes: ["Route estimate", "Private transportation coordination", "Luggage assistance", "Pickup planning"],
    excludes: ["Parking and tolls when applicable", "Child seat unless requested"],
  },
  {
    id: 18,
    slug: "mia-airport-to-cruise-terminal-shuttle",
    name: "MIA Airport to Miami Cruise Terminal Shuttle",
    description: "Ride from Miami International Airport to the Miami cruise terminals with a simple shared shuttle transfer priced per traveler. Choose your arrival or pickup time and head straight to your cruise port without arranging a separate ride.",
    price: 25,
    pricingModel: "per_person",
    duration: "Airport-to-port transfer",
    image: "/images/private-transport-van.webp",
    hours: [],
    flexibleTimeBooking: true,
    timeSelectionLabel: "Select airport pickup time",
    timeSelectionNote: "Choose the time you expect to be ready for pickup at Miami International Airport.",
    category: "Adventure",
    rating: 4.8,
    reviews: 198,
    highlights: ["Miami International Airport pickup", "Direct Miami cruise terminal transfer", "$25 per traveler", "Luggage-friendly shuttle"],
    includes: ["One-way shared shuttle transfer", "Luggage handling", "Cruise terminal drop-off", "Pickup coordination"],
    excludes: ["Return transfer", "Gratuity", "Child seat unless requested"],
  },
];
